/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const ProfileSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={200} className={classes.shortSk} />
          <Skeleton count={2} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <div className={classes.secondPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={200} className={classes.shortSk} />
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={540} className={classes.longBase} />
          <Skeleton count={1} width={340} className={classes.baseSkeleton} />
          <Skeleton count={1} width={420} className={classes.longBase} />

          <div className={classes.dividerContainer}>
            <hr className={classes.border} />
          </div>

          <Skeleton count={1} width={490} className={classes.longBase} />
          <Skeleton count={1} width={540} className={classes.longBase} />
          <Skeleton count={1} width={240} className={classes.baseSkeleton} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <Skeleton count={1} width={120} className={classes.shortSk} />
    </div>
  );
};

export default ProfileSkeleton;
